<template>
    <c-search-form :input-search-items="searchItems" :rows-per-page-items="[10,20,50]" :input-create-items="createItems"
                   :form-name="formName" :create-form-name="createFormName"
                   model="searchForm" :fields="fields" accept-copy
                   key-property="categoryTypeId"
                   search-url="/categoryType/listAll"
                   create-url="/categoryType/save"
                   delete-url="/categoryType/delete">
    </c-search-form>
</template>

<script>
    import CSearchForm from "../../../components/form/ManageForm";
    import axios from "axios";
    import {dbConstants} from "../../../constants";

    export default {
        name: 'categoryType-management',
        components: {CSearchForm},
        data: () => {
            return {
                formName: "lang.category.categoryType",
                createFormName: "lang.category.createCategoryType",
                categoryTypes: [],
                searchItems: [
                    {
                        type: "text",
                        name: "categoryTypeCode",
                        label: "lang.category.categoryTypeCode",
                        placeHolder: "",
                        focus: true
                    },
                    {
                        type: "text",
                        name: "categoryTypeName",
                        label: "lang.category.categoryTypeName",
                        placeHolder: ""
                    }
                ],
                createItems: [
                    {
                        type: "text",
                        name: "categoryTypeCode",
                        label: "lang.category.categoryTypeCode",
                        validate: "required",
                        maxlength: '50',
                        placeHolder: "",
                        errorText: "Lỗi"
                    },
                    {
                        type: "text",
                        name: "categoryTypeName",
                        label: "lang.category.categoryTypeName",
                        validate: "required",
                        maxlength: '250',
                        placeHolder: ""
                    },
                    {
                        type: "select",
                        name: "status",
                        itemText: "statusName",
                        itemValue: "statusValue",
                        items: [{statusValue:1, statusName:"lang.status.active"}, {statusValue:0, statusName:"lang.status.notActive"}],
                        label: "lang.common.status",
                        validate: "required",
                        maxlength: '250',
                        placeHolder: ""
                    }
                ],
                fields: [
                    {
                        value: "index",
                        text: "lang.common.index",
                        width: "5%",
                        sortable: false,
                        headerStyle: "text-align:center"
                    },
                    {
                        value: 'categoryTypeCode',
                        text: 'lang.category.categoryTypeCode',
                        width: "10%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'categoryTypeName',
                        text: 'lang.category.categoryTypeName',
                        width: "20%",
                        sortable: false,
                        headerStyle: "text-align:left"
                    },
                    {
                        text: 'lang.common.status',
                        value: 'status',
                        columnType: 'Integer',
                        optionValues:dbConstants.allStatusValue,
                        component: (value)=>{
                            if(value){
                                return {name: 'v-icon', value:'check', propsData: {color:"green"}}
                            }else{
                                return {name: 'v-icon', value:'close'}
                            }
                        }
                    },
                    {
                        value: 'createAt',
                        text: 'lang.common.create_at',
                        width: "20%",
                        sortable: false,
                        dateFormat: 'dd/MM/yyyy hh:mm',
                        headerStyle: "text-align:left"
                    },
                    {
                        value: 'action',
                        text: "lang.common.actions",
                        width: "20%",
                        sortable: false,
                        compound: true,
                        headerAlign: "center",
                        headerStyle: "text-align:center"
                    }
                ]
            }
        },
    }
</script>
